const isFolder = (id, folderIds) => folderIds.has(id);

const getItemPageIds = (id, params) => {
  const { folderIds, descendantItemIds } = params;

  if (!isFolder(id, folderIds)) {
    return [id];
  }

  return [...(descendantItemIds.get(id) || [])].filter((descId) => !isFolder(descId, folderIds));
};

const getRowPageIds = (id, params) => {
  const { folderIds, expandedFolderIds, anchorId, targetId } = params;

  const isRangeEndpoint = id === anchorId || id === targetId;

  // Skip open folders inside the range, because their pages already appear as their own rows.
  // A folder at a range endpoint contributes all of its pages.
  if (isFolder(id, folderIds) && expandedFolderIds.includes(id) && !isRangeEndpoint) {
    return [];
  }

  return getItemPageIds(id, params);
};

const getRangeSelectionPageIds = (params) => {
  const { visibleOrderIds, anchorId, targetId, selectedItemsMap } = params;

  const anchorIndex = visibleOrderIds.indexOf(anchorId);
  const targetIndex = visibleOrderIds.indexOf(targetId);

  // Return null when a row is not visible so the caller can select a single row.
  if (anchorIndex === -1 || targetIndex === -1) {
    return null;
  }

  const [start, end] =
    anchorIndex < targetIndex ? [anchorIndex, targetIndex] : [targetIndex, anchorIndex];

  const rangePageIds = new Set();
  visibleOrderIds.slice(start, end + 1).forEach((id) => {
    getRowPageIds(id, params).forEach((pageId) => rangePageIds.add(pageId));
  });

  // Select when the target row is not fully selected yet, otherwise deselect.
  const shouldSelect = !getItemPageIds(targetId, params).every(
    (pageId) => selectedItemsMap[pageId]
  );

  return [...rangePageIds].filter((pageId) => shouldSelect !== Boolean(selectedItemsMap[pageId]));
};

export default getRangeSelectionPageIds;
